import { Grid } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CoachList, Title } from "../../../../components";
import { ALL_KEY } from "../../../../components/CustomRadioButton/enumerations/enumerations";
import { useGetCoaches } from "../../../../hooks/Coach/coach.hooks";
import { CoachResponse } from "../../../../hooks/Coach/data";
import { ContentWrapper } from "../../../../layouts/components";
import { useCoachesContext } from "../../context/CoachesContext";
import SkillsFilter from "../SkillsFilter";
import styles from "./styles.module.scss";

const CoachesContainer = () => {
  const { value } = useCoachesContext();
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [filterCoachList, setFilterCoachList] = useState<CoachResponse[]>([]);

  const { data: coachList } = useGetCoaches({ branch_id: "1" }, {});

  useEffect(() => {
    if (!coachList) return;

    if (value === ALL_KEY) {
      setFilterCoachList(coachList);
    } else {
      setFilterCoachList(
        coachList.filter((coach: CoachResponse) =>
          coach.skill_codes.includes(value)
        )
      );
    }
  }, [coachList, value]);

  return (
    <ContentWrapper>
      <div className={styles.coachesContainer}>
        <div
          className={`${styles.titleContainer} ${
            screens.sm ? "" : styles.mobile
          }`}
        >
          <Title title={t("coach.title")} subtitle={t("coach.subtitle")} />
        </div>
        <SkillsFilter />
        <CoachList coachList={filterCoachList} />
      </div>
    </ContentWrapper>
  );
};

export default CoachesContainer;
